import React, { useMemo } from "react";

import { useTranslation } from "@litres-libs/i18n";
import { Label } from "@litres-modules/label";

import { EArtType, type ArtShortSerializer } from "@litres-libs/types";
import FlagIcon from "../../../../../static/icons/flag.svg";
import { Image } from "../../../Image/Image";
import styles from "./SellableItemDetails.module.scss";

export const SellableItemDetails = (art: ArtShortSerializer): JSX.Element => {
  const {
    art_type,
    title,
    persons,
    my_art_status,
    prices,
    is_free,
    library_information,
    read_percent,
    is_draft,
    is_subscription_art,
  } = art;

  const isApproved = library_information
    ? library_information.biblio_selfservice === "received"
    : false;

  const isAcquired =
    my_art_status > 0 ||
    isApproved ||
    prices?.final_price === 0 ||
    is_free ||
    is_subscription_art;

  const { t } = useTranslation();

  const author = useMemo(() => {
    const arr =
      persons
        ?.filter(person => person.role === "author")
        .map(person => t(person.full_name)) || [];
    return arr.slice(0, 2).join(", ") + (arr.length > 2 ? t(" и др.") : "");
  }, [art, t]);

  return (
    <div className={styles.sellableItemDetailsAB}>
      <div className={styles.title}>{title}</div>
      <div className={styles.authors}>{author}</div>
      <div className={styles.info}>
        <div>
          <Label type={art_type} isDraft={is_draft} />
        </div>
        {isAcquired && (
          <div className={styles.progress}>
            {!!read_percent && read_percent > 0 && read_percent < 100 && (
              <>
                <div className={styles.progress__title}>
                  {`${read_percent}%`}
                </div>
                <div className={styles.progress__progressBar}>
                  <div
                    className={styles.progress__progressBar_active}
                    style={{ width: `${read_percent}%` }}
                  />
                </div>
              </>
            )}
            {!!read_percent && read_percent === 100 && (
              <div className={styles.progress__finished}>
                <Image
                  src={FlagIcon}
                  fallbackSrc={FlagIcon}
                  width={10}
                  height={12}
                  alt="tag-icon"
                />
                <span className={styles.progress__finished__text}>
                  {[
                    EArtType.audio,
                    EArtType.podcast,
                    EArtType.podcastEpisode,
                  ].includes(art_type)
                    ? t("Прослушана")
                    : t("Прочитана")}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
